import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeInFromBottom } from '../animations';
import Swiperslider from 'modules/swiper/swiper';
import { viewport } from '../getViewport';

export const storyCta = () => {
  const teasersTop = $$('.story-cta-teaser');

  if (teasersTop.length) {
    fadeInFromBottom(teasersTop);

    teasersTop.forEach(teaser => {
      const slider = new Swiperslider($('.story-cta-teaser__wrapper', teaser), {
        container: teaser,
        scrollbar: {
          hide: true,
        },
      });
      slider.init();
    });
  }

  const teasersBottom = $$('.story .news-teaser');

  if (teasersBottom.length) {
    fadeInFromBottom(teasersBottom);

    const items = $$('.story .news-teaser__item');
    const timeline = gsap.timeline();

    items.forEach(item => {
      gsap.set(item, {
        y: viewport.isReduced
          ? 0
          : viewport.isDesktop
          ? 50
          : viewport.isTablet
          ? 50
          : viewport.isMobile
          ? 0
          : '',
      });

      timeline.to(item, {
        y: 0,
        stagger: {
          each: 1,
        },
      });
    });

    teasersBottom.forEach(teaser => {
      ScrollTrigger.create({
        animation: timeline,
        trigger: teaser,
        start: () => 'top 80%',
        end: () => 'top 40%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });
  }
};
